<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-17 10:18:52
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-24 16:27:17
 * @FilePath: /dsicm-admin-web/src/views/scoentific/src/case-1/index.vue
-->
<template>
  <div class="container-page" style="top:0">
    <CaseHeader @reset="resetHandel" @inquire="inquireHandel"></CaseHeader>
    <!-- 中间列表数据 -->
    <div class="table-content" ref="tableContent">
      <h6>科研管理表</h6>
      <BaseTable :maxHeight="maxTabHeight" :data="tableData" :column="homeColumnConfig" pagination :auto-scroll="true"
        :total="totalPage" :page.sync="listQuery.current" :limit.sync="listQuery.size" @pagination="getPaginationList">
      </BaseTable>
    </div>

  </div>
</template>
<script>
import CaseHeader from "../../components/caseHeader-1";
import caseConfig from "../../common/caseConfig-1.js";
import { apiApplyItem } from "../../api";
import maxTabHeight from "../../common/maxTableHeight";

export default {
  mixins: [caseConfig, maxTabHeight],
  name: "ScoentificCas1",
  data() {
    return {
      listQuery: {
        current: 1,
        size: 10
      },
      totalPage: 0,
      tableData: []
    };
  },
  components: {
    CaseHeader
  },
  methods: {
    /**
     * @description: 分页
     * @param {*}
     * @return {*}
     */

    async getPaginationList() {
      this.getTableList();
    },
    /**
     * @description: 获取表格数据
     * @param {*}
     * @return {*}
     */
    async getTableList() {
      let {
        code,
        data: { records, total }
      } = await apiApplyItem(this.listQuery);
      if (code == 0) {
        this.tableData = records;
        this.totalPage = total;
      }
    },
    /**
     * @description: 重置
     * @param {*}
     * @return {*}
     */

    resetHandel() {
      this.listQuery = this.$options.data().listQuery;
      this.getTableList();
    },

    /**
     * @description: 查询
     * @param {*}
     * @return {*}
     */

    inquireHandel(options) {
      this.listQuery = Object.assign({}, this.listQuery, options);
      this.getTableList();
    }
  }
};
</script>


<style scoped lang="less">
@import "./index.less";
</style>